import { StoreState } from 'state/rootReducer';

export const getSubscriptionDate = ({ userInfo }: StoreState) =>
  userInfo.userData.subscriptionDate;
